import {FACTIONS} from "../../../constants/factions";

export const DARK_ELVES_QUOTES = [{
  quote: 'Для успешной атаки фланга нужно оказаться там быстрее, чем враг поймет, что бой уже начался',
  author: 'Авл Менений Лимфарх, темный эльф, легат Теневого марша',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Проклятие — это не магия. Проклятие — это обещание, которое мы сдерживаем с улыбкой',
  author: 'Тиберия Лордана, темный эльф, магистр Сглазов',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Ты ещё помнишь, как держать свое копьё? Сомневаюсь',
  author: 'Атрамент Гебен, темный эльф, децемвир Отторженных свитков',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Скорость — клинок. Проклятие — яд. А вместе — это ваша эпитафия',
  author: 'Малакар Мортифер, темный эльф, верховный прокуратор Белого подземелья',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Те, кто поумнее, не пытаются от нас убежать',
  author: 'Фебрий Рубец, темный эльф, инспектор Рваных жертв',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Беги быстрее. Это сделает погоню интереснее',
  author: 'Тарквиний Цикута, темный эльф, военный трибун Ядовитого укуса',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Ты ещё держишь свой меч. Молодец. Скоро ты забудешь его имя. Потом — как он выглядит. Потом — зачем он тебе',
  author: 'Фурий Небула, темный эльф, квестор Проклятой амуниции',
  factionId: FACTIONS.DARK_ELVES
}, {
  quote: 'Селестиалы верят в то, что правят судьбами. Мы им не мешаем... верить',
  author: 'Аллиарий Стогной, темный эльф, верховный герольд Пурпурной клятвы',
  factionId: FACTIONS.DARK_ELVES
}]